import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

const namespace = 'widgets';
export const keyPrefix = 'video_archive';

export const useVideoArchiveTranslation = (): UseTranslationResponse<
  typeof namespace,
  typeof keyPrefix
> => useTranslation(namespace, { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Видеоархив',
    no_data: 'Нет данных',
    loading_error: 'Ошибка загрузки',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Video archive',
    no_data: 'No data',
    loading_error: 'Loading error',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Archivo de vídeo',
    no_data: 'Sin datos',
    loading_error: 'Error de carga',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Arquivo de vídeo',
    no_data: 'Sem dados',
    loading_error: 'Erro no carregamento',
  },
}) : {}) as Record<string, unknown>;
